import { reactLocalStorage as Storage } from 'reactjs-localstorage';

// navItems 트리를 순회하여 {path: label} 맵 생성
export const buildLabelMap = (navItems) => {
  const map = {};
  const walk = (items) => {
    if (!items) return;
    items.forEach(it => {
      if (it.to && it.label) map[it.to] = it.label;
      if (it.submenu) walk(it.submenu);
    });
  };
  walk(navItems || []);
  return map;
};

// path → 한글 페이지명. 동적 라우트는 prefix 매칭 (가장 긴 것 우선)
export const getPageLabelByPath = (path, navItems) => {
  if (!path) return '';
  const map = buildLabelMap(navItems);
  if (map[path]) return map[path];
  const keys = Object.keys(map).sort((a, b) => b.length - a.length);
  const hit = keys.find(k => path === k || path.startsWith(k + '/'));
  return hit ? map[hit] : path;
};

// 세션 ID: 30분 비활성 시 만료 → UV 집계용
const SESSION_KEY = 'admin_log_session';
const SESSION_TTL_MS = 30 * 60 * 1000;

export const getSessionId = () => {
  try {
    const raw = Storage.get(SESSION_KEY);
    const now = Date.now();
    if (raw) {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (parsed && parsed.expiresAt > now) {
        parsed.expiresAt = now + SESSION_TTL_MS;
        Storage.set(SESSION_KEY, JSON.stringify(parsed));
        return parsed.id;
      }
    }
    const id = 's_' + now + '_' + Math.random().toString(36).slice(2, 10);
    Storage.set(SESSION_KEY, JSON.stringify({ id, expiresAt: now + SESSION_TTL_MS }));
    return id;
  } catch (e) {
    return 'anon';
  }
};
